/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDataModelRangeNameCategoryRequest } from '../models/CreateDataModelRangeNameCategoryRequest';
import type { DataModelRangeNameCategory } from '../models/DataModelRangeNameCategory';
import type { UpdateDataModelRangeNameCategoryRequest } from '../models/UpdateDataModelRangeNameCategoryRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RangeNameCategoryService {

    /**
     * List range name categories by data model
     * @returns DataModelRangeNameCategory Success
     * @throws ApiError
     */
    public static getRangeNameCategories({
        dataModelId,
    }: {
        /**
         * Data Model Id
         */
        dataModelId: number,
    }): CancelablePromise<Array<DataModelRangeNameCategory>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rangeNameCategory',
            query: {
                'dataModelId': dataModelId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Create range name category
     * @returns DataModelRangeNameCategory Created
     * @throws ApiError
     */
    public static createRangeNameCategory({
        requestBody,
    }: {
        requestBody: CreateDataModelRangeNameCategoryRequest,
    }): CancelablePromise<DataModelRangeNameCategory> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/rangeNameCategory',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }

    /**
     * Update range name category
     * @returns DataModelRangeNameCategory Success
     * @throws ApiError
     */
    public static updateRangeNameCategory({
        categoryId,
        requestBody,
    }: {
        /**
         * Range Name Category Id
         */
        categoryId: number,
        requestBody: UpdateDataModelRangeNameCategoryRequest,
    }): CancelablePromise<DataModelRangeNameCategory> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/rangeNameCategory/{categoryId}',
            path: {
                'categoryId': categoryId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete range name category
     * @returns any Success
     * @throws ApiError
     */
    public static deleteRangeNameCategory({
        categoryId,
    }: {
        /**
         * Range Name Category Id
         */
        categoryId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/rangeNameCategory/{categoryId}',
            path: {
                'categoryId': categoryId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
